/**
 * fastLiveFilter jQuery plugin 1.0.3
 * 
 * Copyright (c) 2011, Anthony Bush
 * License: <http://www.opensource.org/licenses/bsd-license.php>
 * Project Website: http://anthonybush.com/projects/jquery_fast_live_filter/
 **/

jQuery.fn.fastLiveFilter = function (list, options) {
    // Options: input, list, timeout, callback
    options = options || {};
    list = jQuery(list);
    var input = this;
    var lastFilter = '';
    var timeout = options.timeout || 0;
    var callback = options.callback || function () { };

    var keyTimeout;

    // NOTE: because we cache lis & len here, users would need to re-init the plugin
    // if they modify the list in the DOM later.  This doesn't give us that much speed
    // boost, so perhaps it's not worth putting it here.
    var lis = list.children();
    var len = lis.length;
    var oldDisplay = len > 0 ? lis[0].style.display : "block";
    callback(len); // do a one-time callback on initialization to make sure everything's in sync

    input.change(function () {
        if (input.val().length === 0) {
            showFolders(true);
        }
        else {
            showFolders(false);
        }


        var filter = input.val().toLowerCase();
        var li, innerText;
        var numShown = 0;
        for (var i = 0; i < len; i++) {
            li = lis[i];
            innerText = !options.selector ?  li.textContent || li.innerText || "" : $(li).find(options.selector).text();


            if (innerText.toLowerCase().indexOf(filter) >= 0) {
                if (li.style.display === "none") {
                    li.style.display = oldDisplay;

                    // li.closest($(".folder-header")).css("display", "block");
                }
                numShown++;
                //console.log("Li: %o", li);

            } else {
                if (li.style.display !== "none") {
                    li.style.display = "none";
                }
            }
        }
        callback(numShown);
        // var endTime = new Date().getTime();
        // console.log('Search for ' + filter + ' took: ' + (endTime - startTime) + ' (' + numShown + ' results)');
        return false;
    }).keydown(function () {
        clearTimeout(keyTimeout);
        keyTimeout = setTimeout(function () {
            if (input.val() === lastFilter) return;
            lastFilter = input.val();
            input.change();
        }, timeout);
    });
    return this; // maintain jQuery chainability
};

var fastFilterDocLibCallBack = function (total, componentClass) {

    //console.log('fastFilterDocLibCallBack : %o ', $('.searchInput_' + componentClass).length);
    var $inputBox = $('.searchInput_' + componentClass);

    if ($inputBox.length && $inputBox.val().length > 0) {

        // open all the things that are closed
        //console.log('.doc_' + componentClass + ' h4.panel-title a[aria-expanded="false"]');
        $('.doc_' + componentClass + ' h4.panel-title a[aria-expanded!="true"]').click();

        var containers = $(".panel-collapse .panel-body ul.file-list");
        //var tools = $('.file-list__container');

        containers.each(function (index) {
            var thisToolGroup = $(containers[index]);
            //console.log('group : %o', thisToolGroup);
            if (thisToolGroup.children('li').filter(function () { return $(this).css("display") !== "none"; }).length !== 0) {
                //console.log('No visible items');
                thisToolGroup.parent().parent().prev().css('display', 'block');
            } else {
                //console.log('Got visible items');
                thisToolGroup.parent().parent().prev().css('display', 'none');
            }
        });
    }
    else {
        //console.log('Show all headers');
        $('.doc_' + componentClass + ' h4.panel-title a[aria-expanded="true"]').click();
        $('.doc_' + componentClass + ' .panel-heading').css('display', 'block');
        
    }
    cleanUp();
};

function cleanUp() {
    var headers = $(".panel-heading");
    $.each(headers, function (i, v) {    
        if ($(v).next().children().first().find(".file-list__item:not([style='display: none;'])").length === 0) {
            $(v).css("display", "none");
        }
    });
}
function showFolders(empty) {
   
   // console.log("Show folders");
    var headers = $(".folder-header");
    $.each(headers, function (i, v) {
        if (empty === true) {
           
            $(".folder-header").css("display", "block");
        }
        else {
            //console.log($(v).next().find(".file-list__item:not([style='display: none;'])").length);
            if ($(v).next().find(".file-list__item:not([style='display: none;'])").length > 0) {
                $(v).css("display", "block");
            }
        }
    });
}